export { default as Img200 } from './processed/200/leromain.jpg';
export { default as Img400 } from './processed/400/leromain.jpg';
export { default as Imgthumb } from './processed/thumb/leromain.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/leromain.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/leromain.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      190,
      109,
      52
    ],
    "_population": 396,
    "_hsl": [
      0.06884057971014491,
      0.5702479338842976,
      0.4745098039215686
    ]
  },
  "LightVibrant": {
    "_rgb": [
      97,
      172,
      252
    ],
    "_population": 3,
    "_hsl": [
      0.5860215053763441,
      0.9627329192546585,
      0.6843137254901961
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      142,
      68,
      20
    ],
    "_population": 33,
    "_hsl": [
      0.06557377049180328,
      0.7530864197530865,
      0.3176470588235294
    ]
  },
  "Muted": {
    "_rgb": [
      176,
      135,
      111
    ],
    "_population": 446,
    "_hsl": [
      0.06153846153846154,
      0.29147982062780264,
      0.5627450980392157
    ]
  },
  "LightMuted": {
    "_rgb": [
      210,
      164,
      215
    ],
    "_population": 401,
    "_hsl": [
      0.8169934640522875,
      0.3893129770992367,
      0.7431372549019608
    ]
  },
  "DarkMuted": {
    "_rgb": [
      66,
      47,
      37
    ],
    "_population": 187,
    "_hsl": [
      0.057471264367816084,
      0.28155339805825247,
      0.2019607843137255
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/leromain.js